import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../../../../axiosConfig';
import styles from '../../MicroProbe//MicroProbe.module.css';
import ChatNumbersShortTermEconomics from './ChatNumbersShortTermEconomics';
import ShortTermEconomics from './ShortTermEconomics';
import LongTermOutlook from './LongTermOutlook';
import ChatNumbersLongTermOutlook from './ChatNumbersLongTermOutlook';
import BondDataUS from './BondDataUS';
import ChatNumbersUS from '../../Economy/Countries/ChatNumbersUS';


const IndividualBondNumbers = () => {
  const { economyName } = useParams();
  const [inputData, setInputData] = useState(null);
  
  useEffect(() => {
    const fetchInputData = async () => {
      try {
        const response = await axios.get(`/api/country/name/${economyName}`);
        setInputData(response.data);

      } catch (error) {
        console.error('Error fetching currency data:', error);
      }
    };
  
    fetchInputData();
  }, [economyName]);


return (
  <div className={styles.container}>
    <h1 className={styles.title}>{economyName } Bond</h1>

    {inputData && (
      <>  
                
        <div className={`${styles.section} ${styles.sectionQuarter}`}>

          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            {inputData?.name === 'United States' && (
              <BondDataUS inputData={inputData} />
            )}
          </div>


          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            {inputData?.name === 'United States' && (
               <>
                <ChatNumbersUS inputData={inputData} />
                <div className={styles.dividernone}></div>
                </>
            )}
          </div>


          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            {inputData?.name !== 'United States' && (
              <>
                <ShortTermEconomics inputData={inputData} />
                <div className={styles.dividernone}></div>
              </>
            )}
          </div>

          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            {inputData?.name !== 'United States' && (
              <>
                <ChatNumbersShortTermEconomics inputData={inputData} />
                <div className={styles.dividernone}></div>
              </>
            )}
          </div>

          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            <LongTermOutlook inputData={inputData} />
          </div>
          <div className={styles.dividernone}></div> 

          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            <ChatNumbersLongTermOutlook inputData={inputData} />
          </div>
        </div>



      </>
    )}

    <div style={{ marginTop: '20px' }}>
        <Link to="/historical-analysis">Back</Link>
      </div> 
  </div>
);
};

export default IndividualBondNumbers;